<template>
  <div class="header__notification">
    <div v-if="activateUndo" class="undo-popup" :class="activateUndo ? 'fade__in' : 'fade__out'">
      <div>
        <span class="close" @click="hideUndoPopup"><i class="fas fa-times"></i></span>
        <span class="undo__text text-primary fw-bold">{{ activateUndoText }}</span>
        <b-button
          class="header-filter-btns float-right"
          variant="theme"
          @click="undo"
        >
          <span v-if="!isMobile()">Undo</span>
          <i class="fas fa-undo" v-if="isMobile()"></i>
          <span class="sec float-right">10</span>
        </b-button>
      </div>
    </div>
    <b-modal size="lg" hide-footer id="globalAlertDetail" class="modal-global-alert-detail">
      <template slot="modal-title">
        {{alertTitle}}
        <p v-if="alertTime != ''"
          class="notification-sender"
        >sent by {{ alertSender }} @ {{ getLocalAlertTime(alertTime) | moment('MMM Do, hh:mm a') }}</p>
      </template>
      <span v-html="alertDetail"></span>
    </b-modal>
    <b-modal size="xl" hide-footer id="editDeliverableModalAlert" title="" class="modal-edit-deliverable" @hide="editDeliverableModalHidden" @shown="pushRoute" @hidden="removeRoute">
        <EditModal 
        :allContacts="allContacts" 
        modalId="editDeliverableModalAlert"  
        ref="refEditModal" 
        :namespace="''" 
        :tabIndex="tabIndex" 
        />
    </b-modal>
    <div class="dropdown">
      <div
        class="icon cursor-pointer dropdown-toggle mr-2"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        @click="updatePerfectScroll"
      >
        <span v-if="notificationCount" class="notification-count"></span>
        <img
          :class="notificationCount > 0 && !$store.state.deliverables.newNotificationPopupClose ? 'animated' : ''"
          width="30px"
          src="@/csmworkflow/img/bell-module.svg"
        />
      </div>
      <span class="new__notification__popup" 
      v-if="notificationCount > 0 && !$store.state.deliverables.newNotificationPopupClose" 
      :class="newNotificationPopup ? 'fade__in' : 'fade__out'">
        <div @click="$router.currentRoute.name != 'userGlobalAlert' ? $router.push('user-global-alert') : ''; $store.state.deliverables.newNotificationPopupClose=true" 
        class="dropdown-item notification-title text-primary text-center cursor-pointer">
          <span class="close" @click.stop="handlePopupClose">
            <i class="fas fa-times"></i>
          </span>
          <span style="font-weight: normal !important" v-if="notificationCount == 1">You have a new notification.</span>
          <span style="font-weight: normal !important" v-if="notificationCount > 1">You have <span class="fw-bold">{{ notificationCount }}</span> new notifications.</span>
        </div>
      </span>
      <div class="dropdown-menu" :class="notification.length == 0 ? 'no__notification__popup' : ''">
        <div >
          <div class="dropdown-item notification-title text-primary">
            Notifications
            <span class="float-right view-all">
              <router-link 
              href="#" class="dropdown-item" 
              :to="{ name: 'userGlobalAlert' }"
              >View All</router-link>
            </span>
          </div>
          <perfect-scrollbar ref="notification__scroll">
            <span>
              <a
                @click="setAlert(alert)"
                class="dropdown-item notification-item"
                :class="alert.status == 1 ? 'read' : 'unread'"
                :key="'userAlert-'+index"
                v-for="(alert, index) in notification"
                href="#"
              >
                <span class="notification-initials">{{ alert.sender | textInitials }}</span>
                <span class="notification-details" v-if="isNonGeneralAlert(alert)">
                  <span class="notification-title">{{ alert.title }}</span>
                  <span v-if="alert.alert_type == 'chat'">sent by {{ alert.sender }}.</span>

                  <br v-if="alert.task_count > 0 || alert.chat_count > 0 || alert.update_count > 0">
                  <span class="notification-sender" v-if="alert.task_count > 0">
                    +{{ alert.task_count }} 
                    {{ pluralize(alert.task_count, 'task update', 'task updates') }}<template v-if="shouldAddComma(alert, 'task_count')">,</template>
                  </span>

                  <span class="notification-sender" v-if="alert.chat_count > 0">
                    +{{ alert.chat_count }} 
                    {{ pluralize(alert.chat_count, 'message', 'messages') }}<template v-if="shouldAddComma(alert, 'chat_count')">,</template>
                  </span>

                  <span class="notification-sender" v-if="alert.update_count > 0">
                    +{{ alert.update_count }} 
                    {{ pluralize(alert.update_count, 'update', 'updates') }}<template v-if="shouldAddComma(alert, 'update_count')">,</template>
                  </span>

                  <p class="notification-time">{{ fromNowDate(getLocalAlertTime(alert.created_at)) }}</p>
                </span>
                <span class="notification-details" v-else>
                  <!-- system updates and general alerts created by super admin -->
                  <span class="notification-title">{{ alert.title }}</span>
                  <span>sent by {{ alert.sender }}.</span>
                  <p class="notification-time">{{ fromNowDate(getLocalAlertTime(alert.created_at)) }}</p>
                </span>
              </a>
            </span>
          </perfect-scrollbar>
        </div>
        <div v-if="notification.length == 0">
          <span class="dropdown-item notification-title text-center">You have no unread notifications.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import toast from "../../toast";
import EditModal from "../deliverables/EditModal";
export default {
  components: {
    EditModal
  },
  data() {
    return {
      alertTitle: "",
      alertDetail: "",
      alertSender: "",
      alertTime: "",
      enableAnimation: false,
      newNotificationPopup: true,
      tabIndex: 0,
    };
  },
  mounted() {
    let that = this;
    this.fetchNotification({ userId: localStorage.getItem("userId") });

    this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
      if (modalId == 'editDeliverableModalAlert') {
        if (this.taskHighlighted) {
            let editModal = $("#editDeliverableModalAlert");

            this.$nextTick(() => {
              setTimeout(() => {
                let curEl = $(".task-fields .field-block.highlight");
                const elOffset = curEl.offset();
                editModal.scrollTop(elOffset.top - 0.4 * window.innerHeight);
              }, 100);
            });
        }
      }
    });

    $("body").on("click", "#update-logout", function (e) {
      e.preventDefault();
      let alertId = $(this).data("alertid");
      that.$store.dispatch("makeAlertRead", {
        alert: { id: alertId, loggedout: "true" },
      });
      that.$store.dispatch("logout").then(() => that.$router.push("/login"));
    });
    Echo.channel("notification").listen("NotificationAdded", () => {
      this.$store.dispatch("fetchUserAlerts");
      this.$store.dispatch("fetchAlerts");
    });
    Echo.channel("newnotification").listen("NotificationAdded", () => {
      this.$store.dispatch("fetchNotification", {
        userId: localStorage.getItem("userId"),
      });
      this.$store.state.deliverables.newNotificationPopupClose=false;
      this.newNotificationPopup = true;
      this.notificationAnimation();
    });
    this.notificationAnimation();
  },
  computed: {
    ...mapGetters([
      "notification",
      'activateUndoText',
      'activateUndo',
      'deliverableDetail',
      'allContacts',
      'taskHighlighted'
    ]),
    ...mapState({
      getDeliverableTemplateSlug(state, getters) {
        return getters['getDeliverableTemplateSlug']
      },
    }),
    notificationCount() {
      let count = 0;
      if (typeof this.notification != "undefined" && this.notification.length > 0) {
        this.notification.forEach(function (value, key) {
          if (value.status == 0) {
            count++;
          }
        });
      }

      if (count > 0) {
        this.enableAnimation = true;
        let currentTitle = document.title.match(/\(\d+\)/g);
        if (!currentTitle) {
          document.title = "(" + count + ") " + document.title;
        } else {
          document.title =
            "(" +
            count +
            ") " +
            document.title.substr(currentTitle[0].length + 1);
        }
      } else {
        document.title = process.env.MIX_APP_NAME;
      }

      return count;
    },
  },
  methods: {
    ...mapActions([
      "fetchNotification",
      'fetchProjectDeliverableById',
      'getProjectNumberFromId'
    ]),
    ...mapMutations(['setDataLoading']),
    hideUndoPopup() {
      this.$store.commit('setActivateUndo', false);
    },
    shouldAddComma(alert, type) {
      const types = ['task_count', 'chat_count', 'update_count'];
      const currentIndex = types.indexOf(type);
      // there are 8 possible combinations
      // Check if there is a next type with a count > 0
      for (let i = currentIndex + 1; i < types.length; i++) {
        if (alert[types[i]] > 0) {
          return true;
        }
      }
      return false;
    },
    pluralize(count, singular, plural) {
      return count === 1 ? singular : plural;
    },
    undo() {
      let self = this;
      this.$store.dispatch('undoAction').then(function() {
        if(self.$router.currentRoute.name == 'globalSearch') {
          let currentPageNumber = localStorage.getItem('currentPageNumber');
          let currentGSTab = localStorage.getItem('currentGSTab');
          self.$store.dispatch('globalSearch', {type: currentGSTab, page: currentPageNumber});
        }
      });
      this.hideUndoPopup();
    },
    handlePopupClose() {
      this.newNotificationPopup=false; 
      this.$store.state.deliverables.newNotificationPopupClose=true;
    },
    updatePerfectScroll() {
      let self = this;
      self.handlePopupClose();
      setTimeout(function () {
        if(typeof self.$refs.notification__scroll != 'undefined') {
          self.$refs.notification__scroll.update();
        }
      }, 1);
    },
    notificationAnimation() {
      let self = this;
      let animationTimeout = setTimeout(function () {
        $(".header__notification .icon img").removeClass("animated");
        self.enableAnimation = false;
        stopAnimation();
      }, 18000);
      function stopAnimation() {
        clearTimeout(animationTimeout);
      }
    },
    setAlert(alert) {
      this.alertTitle = alert.title;
      this.alertDetail = alert.message;
      this.alertSender = alert.sender;
      this.alertTime = alert.created_at;
      
      if(this.isNonGeneralAlert(alert) == false) {
        // make entire grouped_model_id related alerts read only when modal is opened
        // mark single alert as read for system updates / general alerts
        this.$store.dispatch("makeAlertRead", { alert });
      }

      if (alert.alert_type == "deliverable" || alert.grouped_model == "deliverable") {
        let deliverableId = alert.model_id;
        if (alert.grouped_model == "deliverable") {
          deliverableId = alert.grouped_model_id;
        }
        // Set array of task ids to highlight when modal is opened
        this.$store.dispatch("highlightRelatedTasks", deliverableId);
        this.$store.dispatch("getDeliverableDetail", { deliverableId })
          .then(() => {
            let currentTitle = document.title.match(/\(\d+\)\s/g);
            if(!currentTitle) {
              document.title = this.deliverableDetail.title;
            } else {
              document.title = currentTitle[0] + this.deliverableDetail.title;
            }
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
            if (deliverableTemplateSlug == "media-call") {
              // Only for media calls, contact is tab1, Chat is tab2
              this.tabIndex = 1;
            } else {
              this.tabIndex = 0;
            }
            this.$bvModal.show("editDeliverableModalAlert");
          });
      } else if (alert.alert_type == "project" || alert.grouped_model == "project") {
        let projectId = alert.model_id;
        if (alert.grouped_model == "project") {
          projectId = alert.grouped_model_id;
        }
        this.goToProject(projectId);
      } else if (alert.alert_type == "task") {
        let taskId = alert.model_id;

        this.$store.dispatch("getDeliverableDetailByTask", { taskId })
          .then(() => {
            let currentTitle = document.title.match(/\(\d+\)\s/g);
            if(!currentTitle) {
              document.title = this.deliverableDetail.title;
            } else {
              document.title = currentTitle[0] + this.deliverableDetail.title;
            }
            this.$store.dispatch("highlightTask", taskId);
            this.$bvModal.show("editDeliverableModalAlert");
          });
      } else {
        this.$bvModal.show("globalAlertDetail");
      }
    },

    goToProject(projectId) {
      this.setDataLoading(true);
      this.getProjectNumberFromId(projectId).then((projectNumber) => {
        this.fetchProjectDeliverableById(projectNumber).then(() => {
          this.setDataLoading(false);
          const isNumber = !isNaN(Number(projectNumber));
          if (isNumber) {
            this.$router.push(`/project/${projectNumber}`);
          } else {
            toast.error('Invalid project.');
          }
        });
      })  
    },

    isNonGeneralAlert(alert) {
      return alert.alert_type == "deliverable" || alert.alert_type == "project" || alert.alert_type == "task" || alert.alert_type == "chat";
    },

    getLocalAlertTime(time) {
   		if (time != null && time != "") {
	        const alertTime = this.$moment.utc(time);
	        alertTime.local();
	        return alertTime;
      } else {
      	return null;
      }
    },

    // Deliverable modal related
    editDeliverableModalHidden() {
      this.$store.commit('setDeliverable', this.deliverableDetail)
    },
    pushRoute() {
      if(this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
        history.pushState(
          {},
          null,
          'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
        )
      }
    },
    removeRoute() {
      if(this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
        this.$router.push({name: 'dashboard'});
      } else {
        history.pushState(
          {},
          null,
          this.$router.currentRoute.path
        );
        //this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
      }
    },
  },
};
</script>

<style scoped>
.notification-item{
  font-size: 0.8rem
}
</style>